<template>
  <div class="page-client-management">
    <landing-header />

    <main>
      <section class="hero-clients">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-client">Gestion de la Relation (CRM)</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Centralisez votre <br />
              <span class="gradient-text">capital client</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Transformez chaque fiche client en un dossier structuré et exploitable. Centralisez l'historique, les équipements et les documents pour offrir un service d'excellence.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="client-dashboard-preview shadow-2xl">
              <div class="preview-header">
                <div class="user-avatar"><i class="fa-solid fa-user"></i></div>
                <div>
                  <div class="preview-name">SARL Hôtel de la Paix</div>
                  <div class="preview-sub">3 Sites - 12 Équipements</div>
                </div>
              </div>
              <div class="preview-body">
                <div class="preview-tab active">Fiche Client</div>
                <div class="preview-tab">Interventions</div>
                <div class="preview-tab">Contrats</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white border-t border-gray-100">
        <div class="max-w-7xl auto px-4 mx-auto">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            <div class="client-arg">
              <i class="fa-solid fa-address-card text-orange-500 text-3xl mb-6"></i>
              <h3 class="text-xl font-bold mb-4">Fiche centralisée</h3>
              <p class="text-gray-600 text-sm leading-relaxed">Contact, sites, équipements et contrats regroupés sur une vue unique. Sans recherche ni doublon.</p>
            </div>
            <div class="client-arg">
              <i class="fa-solid fa-clock-rotate-left text-orange-500 text-3xl mb-6"></i>
              <h3 class="text-xl font-bold mb-4">Historique complet</h3>
              <p class="text-gray-600 text-sm leading-relaxed">Conservez la trace de chaque intervention passée ou à venir, des techniciens et des comptes rendus.</p>
            </div>
            <div class="client-arg">
              <i class="fa-solid fa-boxes-stacked text-orange-500 text-3xl mb-6"></i>
              <h3 class="text-xl font-bold mb-4">Suivi du parc installé</h3>
              <p class="text-gray-600 text-sm leading-relaxed">Vision précise de chaque appareil : marque, série, CERFA liés et opérations de maintenance.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row items-center gap-20">
            <div class="lg:w-1/2">
              <div class="portal-tag">Nouveauté</div>
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Le Portail Client : <br/>Votre agence ouverte 24/7</h2>
              <p class="text-gray-600 mb-8">Offrez à vos clients un espace sécurisé pour consulter leurs documents et suivre leur parc d'équipements. Moins d'appels administratifs, plus de professionnalisme.</p>
              <ul class="portal-features">
                <li><i class="fa-solid fa-circle-check"></i> Téléchargement des CERFA et rapports</li>
                <li><i class="fa-solid fa-circle-check"></i> Liste détaillée des équipements</li>
                <li><i class="fa-solid fa-circle-check"></i> Historique des visites d'entretien</li>
              </ul>
            </div>
            <div class="lg:w-1/2">
              <div class="portal-mockup">
                <div class="mock-top">Espace Client Termoflow</div>
                <div class="mock-inner">
                  <div class="mock-card">Mes Documents <i class="fa-solid fa-download"></i></div>
                  <div class="mock-card">Mes Équipements <i class="fa-solid fa-gears"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold mb-16">Une gestion reliée à votre cœur de métier</h2>
          <div class="integration-grid">
            <div class="int-item">Planification</div>
            <div class="int-item">Opérations Terrain</div>
            <div class="int-item">Communication Auto</div>
            <div class="int-item">Statistiques</div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-orange-600 text-white rounded-[3rem] mx-4 my-10">
        <div class="max-w-7xl mx-auto px-8">
          <h2 class="text-3xl font-bold mb-12 text-center">Les bénéfices concrets</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            <div v-for="benefit in benefits" :key="benefit" class="benefit-tag">
              {{ benefit }}
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black mb-8">Structurez votre réussite dès aujourd'hui</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'ClientManagementPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  },
  data() {
    return {
      benefits: [
        'Vision claire à 360°',
        'Zéro doublon de saisie',
        'Gain de temps administratif',
        'Fidélisation facilitée',
        'Image pro renforcée'
      ]
    }
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-clients {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fdf4ff, transparent 40%);
}

.badge-client {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #fff7ed;
  color: #c2410c;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

.client-dashboard-preview {
  background: white;
  border-radius: 2rem;
  overflow: hidden;
  border: 1px solid #f3f4f6;
}

.preview-header {
  background: #f9fafb;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.user-avatar {
  width: 4rem;
  height: 4rem;
  background: #e5e7eb;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 1.5rem;
}

.preview-name { font-weight: 900; font-size: 1.25rem; color: #1f2937; }
.preview-sub { font-size: 0.85rem; color: #6b7280; font-weight: 700; }

.preview-body { padding: 1.5rem; display: flex; gap: 1rem; }
.preview-tab { padding: 0.6rem 1.2rem; border-radius: 0.75rem; font-size: 0.8rem; font-weight: 800; background: #f3f4f6; color: #4b5563; }
.preview-tab.active { background: #f97316; color: white; }

/* --- PORTAL --- */
.portal-tag { color: #f97316; font-weight: 900; text-transform: uppercase; font-size: 0.75rem; margin-bottom: 1rem; }
.portal-features { list-style: none; padding: 0; }
.portal-features li { display: flex; align-items: center; gap: 0.75rem; font-weight: 700; margin-bottom: 0.75rem; color: #4b5563; }
.portal-features li i { color: #16a34a; }

.portal-mockup {
  background: #1f2937;
  border-radius: 2rem;
  padding: 2rem;
  color: white;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}
.mock-top { font-weight: 800; font-size: 0.85rem; padding-bottom: 1rem; border-bottom: 1px solid #374151; margin-bottom: 2rem; }
.mock-card {
  background: #374151;
  padding: 1.5rem;
  border-radius: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 0.9rem;
}

/* --- INTEGRATION --- */
.integration-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}
.int-item {
  padding: 1.5rem 3rem;
  background: #f9fafb;
  border-radius: 1rem;
  font-weight: 800;
  color: #1f2937;
  border: 1px solid #e5e7eb;
}

/* --- BENEFITS --- */
.benefit-tag {
  background: rgba(255,255,255,0.1);
  padding: 1.5rem;
  border-radius: 1.5rem;
  text-align: center;
  font-weight: 800;
  border: 1px solid rgba(255,255,255,0.2);
}

/* --- BUTTONS --- */
.btn-primary { background: linear-gradient(to right, #f97316, #ef4444); color: white; padding: 1rem 2rem; border-radius: 9999px; font-weight: 700; border: none; }
.btn-primary-large { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-clients { text-align: center; padding-top: 8rem; }
  .hero-clients .flex { flex-direction: column; }
  .client-dashboard-preview { margin-top: 4rem; }
}
</style>